import LegalPage from "@/components/LegalPage";

export default function Refund() {
  return (
    <LegalPage title="Refund &amp; Cancellation Policy" lastUpdated="17 September 2026">
      <p>
        This policy explains how refunds and cancellations are handled for purchases
        made on <strong>voicematrix.in</strong>, operated by <strong>VoiceMatrixAI</strong>.
      </p>

      <h2>1. General Principle</h2>
      <p>
        We want you to be satisfied. If a product or service does not meet your
        expectations, contact us and we will review your case fairly.
      </p>

      <h2>2. Digital Products — Reports and Analyses</h2>
      <p>
        <strong>Personalised reports</strong> (Astro-Planetary, Money Nakshatra, Career
        Nakshatra, Relationship Nakshatra, Health reports) are generated specifically
        for you from your voice sample.
      </p>
      <ul>
        <li><strong>Before generation begins:</strong> full refund on request.</li>
        <li><strong>After the report is generated and delivered:</strong> refunds are not available, because the product is personalised and cannot be resold or returned.</li>
        <li><strong>If the report is defective</strong> (missing sections, unreadable PDF, wrong data), we will regenerate it at no cost, or refund in full if regeneration is not possible.</li>
      </ul>

      <h2>3. Digital Downloads — Audio and PDFs</h2>
      <p>
        Audio collections (frequency sounds, mantras, subliminals) and PDF guides
        (diet plans, remedy guides, crystal guides) are delivered as instant downloads.
      </p>
      <ul>
        <li><strong>Before download:</strong> full refund on request.</li>
        <li><strong>After download:</strong> refunds are not available once the file has been accessed, because the product cannot be returned.</li>
      </ul>
      <p>
        If a file is corrupted or does not match its description, contact us and we
        will replace it or refund in full.
      </p>

      <h2>4. Memberships and Subscriptions</h2>
      <ul>
        <li>You may cancel your membership at any time.</li>
        <li>Cancellation takes effect at the end of the current billing period.</li>
        <li><strong>Partial months are not refunded.</strong></li>
        <li>If you were charged in error or did not receive the benefits of your plan, contact us for a full refund of the affected period.</li>
      </ul>

      <h2>5. Workshops and Consultations</h2>
      <ul>
        <li><strong>More than 7 days before the session:</strong> full refund.</li>
        <li><strong>Within 7 days of the session:</strong> 50% refund.</li>
        <li><strong>After the session has taken place:</strong> no refund.</li>
        <li><strong>If we cancel or reschedule:</strong> full refund or credit, your choice.</li>
      </ul>

      <h2>6. How to Request a Refund</h2>
      <p>
        Email <a href="mailto:admin@voicematrix.in">admin@voicematrix.in</a> with:
      </p>
      <ul>
        <li>Your order number or payment reference</li>
        <li>The product or service name</li>
        <li>The reason for your request</li>
      </ul>
      <p>
        We will respond within 3 business days and process approved refunds within
        7–10 business days.
      </p>

      <h2>7. Refund Method</h2>
      <p>Refunds are returned to the original payment method:</p>
      <ul>
        <li><strong>Cards and UPI:</strong> to the same card or UPI ID used for purchase.</li>
        <li><strong>Net banking:</strong> to the same bank account.</li>
      </ul>
      <p>
        Refunds are subject to the timelines of your bank or payment provider
        (typically 5–10 business days after we initiate).
      </p>

      <h2>8. GST and Fees</h2>
      <p>
        GST charged on the original purchase is refunded along with the product price.
        Payment gateway fees deducted at the time of the transaction may not be
        refundable.
      </p>

      <h2>9. Exceptions</h2>
      <p>Refunds will not be granted where:</p>
      <ul>
        <li>The product has been fully consumed or downloaded</li>
        <li>The request is made after the applicable refund window</li>
        <li>The account has violated our Terms and Conditions</li>
        <li>The claim relates to expectations of specific outcomes (see Disclaimer)</li>
      </ul>

      <h2>10. Contact</h2>
      <ul>
        <li><strong>VoiceMatrixAI</strong></li>
        <li><strong>Email:</strong> <a href="mailto:admin@voicematrix.in">admin@voicematrix.in</a></li>
        <li><strong>Address:</strong> Chandigarh, U.T., India</li>
      </ul>
    </LegalPage>
  );
}